/* Home hero — "Living Depth" parallax.
   Mouse + scroll parallax across the spotlight stage layers. Runs only on
   hover-capable, fine-pointer, motion-allowed devices. Writes three
   normalized custom properties (--mx, --my, --sy) on the stage; section-home.css
   maps them to per-layer translate via calc(). Pauses when the hero scrolls
   out of view.

   Deliberately leaves two things alone:
   - the product image hover lift (it lives on .home-hero__product, a separate
     element from the .home-hero__product-link anchor that carries parallax), and
   - the order counter (home-hero-counter.js only swaps text + a class). */
(function () {
  var stage = document.querySelector('.home-hero--spotlight .home-hero__stage');
  if (!stage) return;

  var mm = window.matchMedia;
  var fine = mm && mm('(hover: hover) and (pointer: fine)').matches;
  var reduced = mm && mm('(prefers-reduced-motion: reduce)').matches;
  if (!fine || reduced) return; // touch / coarse pointer / reduced-motion → CSS entrance only

  // --- tunable knobs ---------------------------------------------------
  var MOUSE_EASE = 0.08; // 0..1 — lower is smoother / laggier
  var MOUSE_MAX = 1;     // clamp on the normalized pointer offset (-1..1)
  // Per-layer depth multipliers live in section-home.css (the calc() factors).
  // ---------------------------------------------------------------------

  var hero = stage.closest('.home-hero') || stage;
  var tmx = 0, tmy = 0; // target pointer offset (normalized -1..1)
  var cmx = 0, cmy = 0; // current (lerped toward target)
  var running = false, raf;

  function onMove(e) {
    var r = stage.getBoundingClientRect();
    var x = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
    var y = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
    tmx = Math.max(-MOUSE_MAX, Math.min(MOUSE_MAX, x));
    tmy = Math.max(-MOUSE_MAX, Math.min(MOUSE_MAX, y));
  }

  function onLeave() { tmx = 0; tmy = 0; }

  function scrollProgress() {
    var r = stage.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var center = r.top + r.height / 2;
    // +1 when the stage sits low in the viewport (just entered), 0 centered,
    // -1 as it leaves past the top.
    var p = (vh / 2 - center) / (vh / 2 + r.height / 2);
    return Math.max(-1, Math.min(1, p));
  }

  function frame() {
    cmx += (tmx - cmx) * MOUSE_EASE;
    cmy += (tmy - cmy) * MOUSE_EASE;
    stage.style.setProperty('--mx', cmx.toFixed(4));
    stage.style.setProperty('--my', cmy.toFixed(4));
    stage.style.setProperty('--sy', scrollProgress().toFixed(4));
    if (running) raf = requestAnimationFrame(frame);
  }

  function start() {
    if (running) return;
    running = true;
    stage.classList.add('home-hero__stage--motion');
    raf = requestAnimationFrame(frame);
  }

  function stop() {
    running = false;
    cancelAnimationFrame(raf);
  }

  hero.addEventListener('mousemove', onMove);
  hero.addEventListener('mouseleave', onLeave);

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) start();
      else stop();
    }, { threshold: 0 }).observe(stage);
  } else {
    start();
  }
})();
